<h1>Welcome to the Project Portfolio Application</h1>
<p>Please <button (click)="login()" title="Login into the application">Login</button> into the application in order to view any projects.</p>